/*============================================================================
Accordion tabs
==============================================================================*/

$('.accordion-tab .accordion-title').click(function(){
	$(this).parent().toggleClass('active');
  $(this).next().slideToggle();
});